// Auto-generated by collect-docs.ts - DO NOT EDIT
import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  topNavigation: [
    {
        "id": "docs",
        "label": "Guides"
    },
    {
        "id": "plaid-service-api",
        "label": "Plaid Service"
    },
    {
        "id": "auth-api",
        "label": "Authentication"
    },
    {
        "id": "events-service-api",
        "label": "Events Service"
    }
],
  sidebar: {
    docs: [
    {
        "type": "category",
        "label": "Plaid Service",
        "items": [
            "plaid-service/guides/overview",
            "plaid-service/guides/account-linking",
            "plaid-service/guides/authentication",
            "plaid-service/guides/error-reference",
            "plaid-service/guides/reverse-proxy",
            "plaid-service/guides/token-management"
        ]
    },
    {
        "type": "category",
        "label": "Plaid Service - Code Samples",
        "items": [
            "plaid-service/samples/curl",
            "plaid-service/samples/javascript"
        ]
    },
    {
        "type": "category",
        "label": "Authentication",
        "items": [
            "auth/guides/overview"
        ]
    },
    {
        "type": "category",
        "label": "Events Service",
        "items": [
            "events-service/guides/local-development",
            "events-service/guides/publishing-events"
        ]
    }
],
  },
  apis: [
    {
        "type": "file",
        "input": "./.generated/openapi/plaid-service.json",
        "navigationId": "plaid-service-api"
    },
    {
        "type": "file",
        "input": "./.generated/openapi/auth.json",
        "navigationId": "auth-api"
    },
    {
        "type": "file",
        "input": "./.generated/openapi/events-service.json",
        "navigationId": "events-service-api"
    }
],
  docs: {
    files: "/pages/**/*.{md,mdx}",
  },
  metadata: {
    title: "Service CU Developer Portal",
    description: "API Documentation for Service CU Cloud Services",
  },
};

export default config;
